(function () {
  function initStickyElement() {
    var stickyElement = document.querySelector('.sticky-element');
    var scrollContainer = document.querySelector('.page-wrapper');

    if (!stickyElement || !scrollContainer) {
      setTimeout(initStickyElement, 500);
      return;
    }

    if (stickyElement.dataset.stickyInit === 'true') return;
    stickyElement.dataset.stickyInit = 'true';

    function toggleStickyElement() {
      var scrollTop = scrollContainer.scrollTop || 0;
      var scrollHeight = scrollContainer.scrollHeight || 0;
      var clientHeight = scrollContainer.clientHeight || 0;
      var scrollableHeight = scrollHeight - clientHeight;

      var scrollPercent = scrollableHeight > 0
        ? (scrollTop / scrollableHeight) * 100
        : 0;

      if (scrollPercent >= 20) {
        stickyElement.classList.add('show-sticky');
      } else {
        stickyElement.classList.remove('show-sticky');
      }
    }

    scrollContainer.addEventListener('scroll', toggleStickyElement, { passive: true });
    window.addEventListener('resize', toggleStickyElement);

    setTimeout(toggleStickyElement, 300);
    setTimeout(toggleStickyElement, 1000);
    toggleStickyElement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyElement);
  } else {
    initStickyElement();
  }

  window.addEventListener('load', initStickyElement);
})();